/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import React from 'react';

/**
 * MaterialRounded Accessibility.
 * @export
 */
export const ICON_ACCESSIBILITY = (
  <svg fill="none" height="28" viewBox="0 0 28 28" width="28" xmlns="http://www.w3.org/2000/svg">
    <path
      clipRule="evenodd"
      d="M16.3333 4.66683C16.3333 3.3835 15.2833 2.3335 14 2.3335C12.7167 2.3335 11.6667 3.3835 11.6667 4.66683C11.6667 5.95016 12.7167 7.00016 14 7.00016C15.2833 7.00016 16.3333 5.95016 16.3333 4.66683ZM17.5 10.5002H23.3333C23.975 10.5002 24.5 9.97516 24.5 9.3335C24.5 8.69183 23.975 8.16683 23.3333 8.16683H4.66667C4.025 8.16683 3.5 8.69183 3.5 9.3335C3.5 9.97516 4.025 10.5002 4.66667 10.5002H10.5V24.5002C10.5 25.1418 11.025 25.6668 11.6667 25.6668C12.3083 25.6668 12.8333 25.1418 12.8333 24.5002V18.6668H15.1667V24.5002C15.1667 25.1418 15.6917 25.6668 16.3333 25.6668C16.975 25.6668 17.5 25.1418 17.5 24.5002V10.5002Z"
      fill="#707070"
      fillRule="evenodd"
    />
  </svg>
);
